import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getBuyerProfile = ()=>
  api.get(ENDPOINTS.BUYER_PROFILE.GET);

export const updateBuyerProfile = (data)=>
  api.put(ENDPOINTS.BUYER_PROFILE.UPDATE,data);